export { default } from './connection-banner';
